export const COLORS = {
  background: "#ffc0cb"
}